import { getSource, imgSizes } from '../components/UI/WpImage/WpImage';

const DEFAULT_WIDTH = 1024;

function getObj( image ) {
  let metaObj = null;

  if( image?.mediaDetails ) {
    metaObj = getSource(
      image.sourceUrl,
      image.mediaDetails,
      { size: imgSizes.LARGE },
      true
    )
  } else if( image?.localFile ) {
    const imageData = image.localFile.childImageSharp?.gatsbyImageData;
    const width = imageData.layout === 'constrained' ? imageData.width : DEFAULT_WIDTH;
    const height = imageData.layout === 'constrained' ? imageData.height : Math.round(DEFAULT_WIDTH * imageData.height);

    metaObj = {
      src: imageData.images.fallback.src,
      width,
      height
    }
  }

  return metaObj;
}

const getMetaImage = (image, fallback) => {
  return image ? getObj( image ) : getObj( fallback );
}

export default getMetaImage;